// PDF report page styles — injected as a <style> tag into the hidden render container.
// Class names match reportPages.css exactly.

const PDF_STYLES = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+KR:wght@300;400;500;600;700&family=Noto+Serif+KR:wght@300;400;500;600;700&display=swap');

/* ── Reset — 외부 스타일 오염 방지 ── */
.cover-art, .cover-art *,
.pdf-page, .pdf-page *,
.p02, .p02 *,
.p03, .p03 *,
.p04, .p04 *,
.p05, .p05 *,
.p06, .p06 *,
.p99, .p99 * {
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  box-sizing: border-box;
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  line-height: normal;
  letter-spacing: -0.01em;
  -webkit-font-smoothing: antialiased;
}
.cover-art table, .p02 table, .p03 table, .p04 table, .p05 table, .p06 table, .p99 table {
  border-collapse: collapse;
  border-spacing: 0;
}
.cover-art td, .p02 td, .p03 td, .p04 td, .p05 td, .p06 td, .p99 td,
.cover-art th, .p02 th, .p03 th, .p04 th, .p05 th, .p06 th, .p99 th {
  border: none;
  padding: 0;
}
.cover-art img, .p02 img, .p03 img, .p04 img, .p05 img, .p06 img, .p99 img {
  max-width: none;
  border: none;
}

:root {
  --c-bg: #f4f1ea;
  --c-paper: #faf7ef;
  --c-ink: #14213d;
  --c-ink-soft: #4a5468;
  --c-ink-muted: #8a92a3;
  --c-rule: #d8d2c2;
  --c-accent: #c9a961;
  --c-hairline: rgba(20, 33, 61, 0.18);
}

/* ============================================================
   공통 페이지 래퍼 — pdf-page
   ============================================================ */
.pdf-page {
  width: 1123px;
  height: 794px;
  box-sizing: border-box;
  background: var(--c-paper);
  color: var(--c-ink);
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-size: 11px;
  letter-spacing: -0.01em;
  position: relative;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  display: grid;
  grid-template-rows: auto 1fr auto;
  padding: 44px 56px 32px;
}
.pdf-page .num { font-family: 'Inter', system-ui; font-feature-settings: 'tnum' 1; }
.pdf-page .serif { font-family: 'Noto Serif KR', serif; font-weight: 400; letter-spacing: -0.025em; }

.pdf-page__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 22px;
  border-bottom: 1px solid var(--c-rule);
}
.pdf-page__top .left {
  font-size: 10px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-soft);
  font-weight: 500;
}
.pdf-page__top .right {
  font-size: 9px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
}

.pdf-page__body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.pdf-page__body > *:last-child {
  flex: 1;
  min-height: 0;
}

.pdf-page__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 18px;
  border-top: 1px solid var(--c-rule);
  font-size: 9px;
  letter-spacing: 0.2em;
  color: var(--c-ink-muted);
  text-transform: uppercase;
  font-weight: 400;
}
.pdf-page__bottom .num { font-family: 'Inter', system-ui; }

/* ============================================================
   Cover
   ============================================================ */
.cover-art {
  width: 1123px;
  height: 794px;
  box-sizing: border-box;
  background: var(--c-paper);
  color: var(--c-ink);
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-size: 11px;
  letter-spacing: -0.01em;
  position: relative;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
}
.cover-art .num { font-family: 'Inter', system-ui; font-feature-settings: 'tnum' 1; }
.cover-art .serif { font-family: 'Noto Serif KR', serif; font-weight: 400; letter-spacing: -0.025em; }

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 10px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-soft);
  font-weight: 500;
}
.brand__mark {
  width: 22px; height: 22px;
  border: 1.2px solid var(--c-ink);
  display: grid; place-items: center;
  font-family: 'Noto Serif KR', serif;
  font-size: 13px;
  font-weight: 500;
  color: var(--c-ink);
  letter-spacing: 0;
}

.photo {
  background:
    repeating-linear-gradient(135deg, rgba(20,33,61,0.06) 0 1px, transparent 1px 18px),
    linear-gradient(180deg, #d9d2c2 0%, #b8b1a0 100%);
  position: relative;
  overflow: hidden;
}
.photo::after {
  content: attr(data-label);
  position: absolute;
  bottom: 14px; right: 16px;
  font-family: 'Inter', system-ui;
  font-size: 9px;
  letter-spacing: 0.2em;
  color: rgba(255,255,255,0.7);
  text-transform: uppercase;
  font-weight: 500;
  display: none;
}

/* C3 */
.c3 { display: grid; grid-template-columns: 1fr 1fr; }
.c3__left {
  padding: 44px 56px;
  display: grid;
  grid-template-rows: auto 1fr auto;
  position: relative;
}
.c3__top { display: flex; justify-content: space-between; align-items: flex-start; }
.c3__top .num { font-size: 9px; letter-spacing: 0.18em; color: var(--c-ink-muted); }

.c3__center {
  align-self: center;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 28px;
  align-items: stretch;
}
.c3__vline {
  font-family: 'Noto Serif KR', serif;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0.5em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
  writing-mode: vertical-rl;
  text-orientation: mixed;
  align-self: center;
  padding: 8px 0;
  border-top: 1px solid var(--c-ink);
  border-bottom: 1px solid var(--c-ink);
}
.c3__title-wrap { display: flex; flex-direction: column; justify-content: center; }
.c3__eyebrow {
  font-size: 10px;
  letter-spacing: 0.32em;
  text-transform: uppercase;
  color: var(--c-accent);
  font-weight: 600;
  margin-bottom: 20px;
}
.c3__title {
  font-family: 'Noto Serif KR', serif;
  font-weight: 400;
  font-size: 38px;
  line-height: 1.7;
  letter-spacing: -0.025em;
  margin: 0;
}
.c3__title em { font-style: normal; color: inherit; font-weight: 400; }
.c3__sub {
  margin-top: 22px;
  padding-top: 16px;
  border-top: 1px solid var(--c-rule);
  font-size: 10px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--c-ink-soft);
}
.c3__bottom {
  font-size: 9px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
  display: flex;
  justify-content: space-between;
  padding-top: 14px;
  border-top: 1px solid var(--c-rule);
}
.c3__photo { height: 100%; }


/* ============================================================
   Page 02 — Profile
   ============================================================ */
.p02 {
  width: 1123px;
  height: 794px;
  box-sizing: border-box;
  background: var(--c-paper);
  color: var(--c-ink);
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-size: 11px;
  letter-spacing: -0.01em;
  position: relative;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  display: grid;
  grid-template-rows: auto 1fr auto;
  padding: 44px 56px 32px;
}

.p02__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 22px;
  border-bottom: 1px solid var(--c-rule);
}
.p02__top .left {
  font-size: 10px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-soft);
  font-weight: 500;
}
.p02__top .right {
  font-size: 9px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
}

.p02__body {
  display: grid;
  grid-template-columns: 0.95fr 1fr;
  gap: 56px;
  padding: 16px 0 24px;
  align-items: stretch;
}

.p02__photo {
  background-size: cover;
  background-position: center;
  height: 100%;
  min-height: 460px;
}

.p02__info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.p02__chapter {
  font-family: 'Noto Serif KR', serif;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: var(--c-accent);
  margin-top: 16px;
  margin-bottom: 14px;
}
.p02__title {
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-weight: 500;
  font-size: 28px;
  line-height: 1.25;
  letter-spacing: -0.025em;
  margin: 0 0 18px;
  color: var(--c-ink);
}
.p02__title small {
  display: block;
  font-family: 'Noto Sans KR', system-ui;
  font-size: 11px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
  margin-top: 10px;
  font-weight: 500;
}

.p02__specs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid #a8a293;
  margin: 0;
}
.p02__specs > div {
  padding: 12px 0;
  border-bottom: 1px solid var(--c-rule);
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.p02__specs > div:nth-child(odd) {
  padding-right: 24px;
  border-right: 1px solid var(--c-rule);
}
.p02__specs > div:nth-child(even) { padding-left: 24px; }
.p02__specs dt {
  font-size: 9px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
  font-weight: 500;
}
.p02__specs dd {
  margin: 0;
  font-family: 'Inter', 'Noto Sans KR', system-ui;
  font-feature-settings: 'tnum' 1;
  font-size: 14px;
  font-weight: 500;
  color: var(--c-ink);
  letter-spacing: -0.005em;
}
.p02__specs dd .unit {
  font-size: 11px;
  font-weight: 400;
  color: var(--c-ink-muted);
  margin-left: 3px;
  letter-spacing: 0.02em;
}
.p02__specs .full {
  grid-column: span 2;
  padding-right: 0 !important;
  padding-left: 0 !important;
  border-right: 0 !important;
}
.p02__specs .price dd {
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
}
.p02__specs .price dd .sub {
  display: block;
  font-family: 'Inter', system-ui;
  font-size: 11px;
  color: var(--c-ink-muted);
  font-weight: 400;
  margin-top: 8px;
  letter-spacing: 0.02em;
}

.p02__bottom {
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  letter-spacing: 0.2em;
  color: var(--c-ink-muted);
  text-transform: uppercase;
  padding-top: 18px;
  border-top: 1px solid var(--c-rule);
}
.p02__bottom .num { font-family: 'Inter', system-ui; }


/* ============================================================
   Page 03 — Gallery
   ============================================================ */
.p03 {
  width: 1123px;
  height: 794px;
  box-sizing: border-box;
  background: var(--c-paper);
  color: var(--c-ink);
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-size: 11px;
  letter-spacing: -0.01em;
  position: relative;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  display: grid;
  grid-template-rows: auto 1fr auto;
  padding: 44px 56px 32px;
}

.p03__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 22px;
  border-bottom: 1px solid var(--c-rule);
}
.p03__top .left {
  font-size: 10px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-soft);
  font-weight: 500;
}
.p03__top .right {
  font-size: 9px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
}

.p03__band {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  margin-top: 22px;
  padding: 14px 20px;
  background: #f1ede3;
  border-radius: 2px;
}
.p03__chapter {
  font-family: 'Noto Serif KR', serif;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: var(--c-accent);
}

.p03__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 18px;
  border-top: 1px solid var(--c-rule);
  font-size: 9px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
}
.p03__bottom .num { font-family: 'Inter', system-ui; }

.p03__body {
  display: grid;
  gap: 14px;
  padding: 18px 0 18px;
  min-height: 0;
}

.tile {
  background-color: #c8c2b2;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
  min-height: 0;
}
.tile--photo .cap {
  position: absolute;
  bottom: 12px; left: 14px;
  font-family: 'Inter', system-ui;
  font-size: 9px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.92);
  font-weight: 500;
  text-shadow: 0 1px 3px rgba(0,0,0,0.4);
}

.p03--a .p03__body { grid-template-columns: 1fr; }

.p03--b .p03__body {
  grid-template-columns: 1.7fr 1fr;
  grid-template-rows: 1fr 1fr;
}
.p03--b .b-1 { grid-row: 1 / span 2; }

.p03--d .p03__body {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr 1fr;
}


/* ============================================================
   Page 04 — Description
   ============================================================ */
.p04 {
  width: 1123px;
  height: 794px;
  box-sizing: border-box;
  background: var(--c-paper);
  color: var(--c-ink);
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-size: 11px;
  letter-spacing: -0.01em;
  position: relative;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  display: grid;
  grid-template-rows: auto 1fr auto;
  padding: 44px 56px 32px;
}

.p04__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 22px;
  border-bottom: 1px solid var(--c-rule);
}
.p04__top .left {
  font-size: 10px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-soft);
  font-weight: 500;
}
.p04__top .right {
  font-size: 9px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
}

.p04__band {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  margin-top: 22px;
  padding: 14px 20px;
  background: #f1ede3;
  border-radius: 2px;
}
.p04__chapter {
  font-family: 'Noto Serif KR', serif;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: var(--c-accent);
}

.p04__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 18px;
  border-top: 1px solid var(--c-rule);
  font-size: 9px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
}
.p04__bottom .num { font-family: 'Inter', system-ui; }

.p04__title {
  font-family: 'Noto Sans KR', system-ui;
  font-weight: 500;
  font-size: 30px;
  line-height: 1.35;
  letter-spacing: -0.03em;
  color: var(--c-ink);
  margin: 0;
  text-wrap: balance;
}

.prose {
  font-family: 'Noto Sans KR', system-ui;
  font-size: 13px;
  line-height: 1.95;
  color: var(--c-ink);
  font-weight: 400;
  letter-spacing: -0.005em;
  text-wrap: pretty;
}
.prose p { margin: 0 0 12px; }
.prose p:last-child { margin-bottom: 0; }

/* ── A · Stacked Editorial (제목 위, 본문 아래 전체 폭) ── */
.p04--a .p04__body {
  padding: 30px 0 18px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.p04--a .p04__head { max-width: 880px; }
.p04--a .prose { max-width: 880px; }

/* ── B · Side Title (제목 왼쪽, 본문 오른쪽) ── */
.p04--b .p04__body {
  padding: 30px 0 18px;
  display: grid;
  grid-template-columns: 360px 1fr;
  gap: 56px;
}
.p04--b .p04__head {
  border-right: 1px solid var(--c-rule);
  padding-right: 40px;
}
.p04--b .p04__title { font-size: 26px; line-height: 1.6; }


/* ============================================================
   Page 05 — Location
   ============================================================ */
.p05 {
  width: 1123px;
  height: 794px;
  box-sizing: border-box;
  background: var(--c-paper);
  color: var(--c-ink);
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-size: 11px;
  letter-spacing: -0.01em;
  position: relative;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  display: grid;
  grid-template-rows: auto 1fr auto;
  padding: 44px 56px 32px;
}

.p05__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 22px;
  border-bottom: 1px solid var(--c-rule);
}
.p05__top .left {
  font-size: 10px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-soft);
  font-weight: 500;
}
.p05__top .right {
  font-size: 9px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
}

.p05__band {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  margin-top: 22px;
  padding: 14px 20px;
  background: #f1ede3;
  border-radius: 2px;
}
.p05__chapter {
  font-family: 'Noto Serif KR', serif;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: var(--c-accent);
}

.p05__body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 24px 0 22px;
  min-height: 0;
}
.p05__fig {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 0;
}
.p05__caption {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--c-rule);
}
.p05__cap-tag {
  font-family: 'Inter', system-ui;
  font-size: 22px;
  letter-spacing: 0.06em;
  font-weight: 600;
  color: var(--c-accent);
}
.p05__cap-title {
  font-family: 'Noto Sans KR', system-ui;
  font-size: 22px;
  font-weight: 500;
  color: var(--c-ink);
  letter-spacing: -0.02em;
}

.p05__slot {
  flex: 1;
  min-height: 0;
  background: #ece8df;
  border: 1px solid #cdc6b6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--c-ink-muted);
}
.p05__slot--cad {
  background: #e8ece7;
  border-color: #b1bbaa;
}
.p05__map-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  flex: 1;
  min-height: 0;
}

.p05__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 18px;
  border-top: 1px solid var(--c-rule);
  font-size: 9px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
}
.p05__bottom .num { font-family: 'Inter', system-ui; }


/* ============================================================
   Page 06 — Land & Page 07 — Basic/Building
   ============================================================ */
.p06 {
  width: 1123px;
  height: 794px;
  box-sizing: border-box;
  background: var(--c-paper);
  color: var(--c-ink);
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-size: 12px;
  letter-spacing: -0.01em;
  position: relative;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  display: grid;
  grid-template-rows: auto 1fr auto;
  padding: 44px 56px 32px;
}

.p06__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 22px;
  border-bottom: 1px solid var(--c-rule);
}
.p06__top .left {
  font-size: 10px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-soft);
  font-weight: 500;
}
.p06__top .right {
  font-size: 9px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
}

.p06__chapter {
  display: flex;
  align-items: baseline;
  gap: 18px;
  padding: 22px 0 18px;
}
.p06__chapter .eyebrow {
  font-family: 'Noto Serif KR', serif;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: var(--c-accent);
}
.p06__chapter .title {
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-weight: 500;
  font-size: 26px;
  letter-spacing: -0.02em;
  color: var(--c-ink);
  margin: 0;
}

.p06__body {
  background: #f1ede3;
  padding: 40px 48px;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.p06__sec-h {
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--c-ink);
  margin: 0 0 22px;
  padding-bottom: 14px;
  border-bottom: 1px solid #a8a293;
  display: flex;
  align-items: baseline;
  gap: 14px;
}
.p06__sec-h .en {
  font-family: 'Inter', system-ui;
  font-weight: 400;
  font-size: 10px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
}

.p06__profile {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 56px;
  row-gap: 0;
  margin: 0;
}
.p06__row {
  display: grid;
  grid-template-columns: 130px 1fr;
  align-items: baseline;
  padding: 18px 0;
  border-bottom: 1px dashed rgba(20, 18, 14, 0.16);
  gap: 16px;
  margin: 0;
}
.p06__row dt {
  font-size: 13px;
  letter-spacing: 0.01em;
  color: var(--c-ink-soft);
  font-weight: 500;
}
.p06__row dd {
  margin: 0;
  font-family: 'Inter', 'Noto Sans KR', system-ui;
  font-feature-settings: 'tnum' 1;
  font-size: 16px;
  font-weight: 500;
  color: var(--c-ink);
  letter-spacing: -0.005em;
  text-align: right;
}
.p06__row dd .unit {
  font-size: 12px;
  font-weight: 400;
  color: var(--c-ink-muted);
  margin-left: 3px;
}
.p06__row dd .sub {
  display: block;
  font-size: 11px;
  font-weight: 400;
  color: var(--c-ink-muted);
  margin-top: 2px;
  letter-spacing: 0.01em;
}

.p06__bottom {
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  letter-spacing: 0.2em;
  color: var(--c-ink-muted);
  text-transform: uppercase;
  padding-top: 18px;
  border-top: 1px solid var(--c-rule);
  margin-top: 22px;
}
.p06__bottom .num { font-family: 'Inter', system-ui; }

.p07__cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 56px;
}
.p07__profile { grid-template-columns: 1fr !important; gap: 0 !important; }
.p07__profile .p06__row { padding: 9px 0 !important; font-size: 13px; }
.p07__profile .p06__row dt { font-size: 13px; }
.p07__profile .p06__row dd { font-size: 14px; }


/* ============================================================
   Page Last — Contact
   ============================================================ */
.p99 {
  width: 1123px;
  height: 794px;
  box-sizing: border-box;
  background: var(--c-paper);
  color: var(--c-ink);
  font-family: 'Noto Sans KR', system-ui, sans-serif;
  font-size: 11px;
  letter-spacing: -0.01em;
  position: relative;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  display: grid;
  grid-template-rows: auto 1fr auto;
  padding: 44px 56px 32px;
}

.p99__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 22px;
  border-bottom: 1px solid var(--c-rule);
}
.p99__top .left {
  font-size: 10px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-soft);
  font-weight: 500;
}
.p99__top .right {
  font-size: 9px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
}

.p99__body {
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  gap: 72px;
  padding: 60px 0 36px;
  align-items: stretch;
}

.p99__hero {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.p99__chapter {
  font-family: 'Noto Serif KR', serif;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: var(--c-accent);
}

.p99__headline {
  font-family: 'Noto Serif KR', serif;
  font-weight: 400;
  font-size: 44px;
  line-height: 1.55;
  letter-spacing: -0.025em;
  margin: 0;
  color: var(--c-ink);
}
.p99__headline em {
  font-family: 'Noto Serif KR', serif;
  font-style: normal;
  font-weight: 400;
  color: var(--c-accent);
}

.p99__lede {
  font-size: 12px;
  line-height: 1.85;
  color: var(--c-ink-soft);
  letter-spacing: 0.01em;
  max-width: 38ch;
}

.p99__sign {
  font-family: 'Noto Serif KR', serif;
  font-style: italic;
  font-size: 14px;
  color: var(--c-ink-muted);
}

.p99__info {
  border-top: 1px solid #a8a293;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  align-self: end;
}

.p99__group {
  padding: 22px 0;
  border-bottom: 1px solid var(--c-rule);
}
.p99__group:last-child { border-bottom: 0; padding-bottom: 0; }

.p99__group-label {
  font-size: 9px;
  letter-spacing: 0.32em;
  text-transform: uppercase;
  color: var(--c-accent);
  font-weight: 600;
  margin-bottom: 16px;
}

.p99__rows {
  display: grid;
  grid-template-columns: 90px 1fr;
  gap: 12px 24px;
  margin: 0;
}
.p99__rows dt {
  font-size: 10px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--c-ink-muted);
  font-weight: 500;
  padding-top: 4px;
}
.p99__rows dd {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: var(--c-ink);
  letter-spacing: -0.005em;
}
.p99__rows dd .num {
  font-family: 'Inter', 'Noto Sans KR', system-ui;
  font-feature-settings: 'tnum' 1;
}

.p99__person {
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.p99__person .role {
  font-size: 15px;
  font-weight: 500;
  color: var(--c-ink);
}

.p99__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 22px;
  border-top: 1px solid var(--c-rule);
}
.p99__bottom .num { font-family: 'Inter', system-ui; }
`;

export default PDF_STYLES;
